export default {
    address: 'address',
    activity: 'activity',
    bill: 'bill',
    calendar_event: 'calendar event',
    campaign: 'campaign',
    campaign_template: 'campaign template',
    contact: 'contact',
    contact_list: 'contact list',
    contract: 'contract',
    credit_note: 'credit note',
    customer: 'customer',
    domain: 'domain',
    equipment: 'equipment',
    expense: 'expense',
    hosting_account: 'hosting account',
    invoice: 'invoice',
    journal_entry: 'journal entry',
    ledger_entry: 'ledger entry',
    opportunity: 'opportunity',
    product: 'product',
    project: 'project',
    prospect: 'prospect',
    public_form: 'public form',
    quote: 'quote',
    recurring_schedule: 'recurrence',
    supplier: 'supplier',
    survey: 'survey',
    task: 'task',
    ticket: 'ticket',
    warehouse: 'warehouse'
};
